/* Wrist sizer "?" trigger next to size options on product pages.
   Adds a small circled ? to the RIGHT of any size option label (Wrist Size,
   Bracelet Size, Size...) but not Bead Size. Clicking it opens a popout:
   - on a computer: a "measure your wrist" info card WITH a QR code to scan
     and continue on the phone;
   - on a phone: the same info WITH a button that opens the wrist sizer in a
     new window. */
(function () {
  'use strict';
  if (window.__wszqInit) return;
  window.__wszqInit = true;

  var PAGE_URL = '/pages/wrist-sizer';
  var FULL_URL = 'https://www.serenityartnhome.com/pages/wrist-sizer';
  var DESKTOP_MIN_PX = 768;
  // Read at open time, not init — the QR asset var is set by an inline
  // script that may run in a different order across templates.
  function qrSrc() { return window.__wszqQrSrc || ''; }

  var css = [
    '.wszq-trigger{display:inline-flex;align-items:center;justify-content:center;',
    'width:17px;height:17px;margin-left:8px;border:1px solid rgba(35,35,35,0.35);',
    'border-radius:50%;font:400 11px/1 "Hanken Grotesk",sans-serif;color:#232323;',
    'text-decoration:none;vertical-align:1px;cursor:pointer;background:none;padding:0;flex:0 0 auto;}',
    '.wszq-trigger:hover{background:#232323;color:#f8f7f5;}',
    '.wszq-overlay{position:fixed;inset:0;background:rgba(35,35,35,0.45);z-index:9999;',
    'display:flex;align-items:center;justify-content:center;padding:24px;}',
    '.wszq-panel{background:#f8f7f5;color:#232323;max-width:340px;width:100%;',
    'padding:38px 30px 30px;text-align:center;position:relative;',
    'font:300 14px/1.5 "Hanken Grotesk",sans-serif;}',
    '.wszq-title{font:400 21px/1.3 "Cormorant Garamond",Georgia,serif;',
    'letter-spacing:0.08em;margin:0 0 12px;}',
    '.wszq-panel p{margin:0 0 20px;color:#6d6a67;font-size:13px;}',
    '.wszq-qr{width:180px;height:180px;display:block;margin:0 auto 12px;}',
    '.wszq-scan{font-size:11px;letter-spacing:0.14em;color:#8a8784;margin:0 0 4px;}',
    '.wszq-cta{display:block;width:100%;box-sizing:border-box;background:#232323;',
    'color:#f8f7f5;text-decoration:none;padding:15px 20px;font:400 12px/1 "Hanken Grotesk",sans-serif;',
    'letter-spacing:0.16em;}',
    '.wszq-cta:hover{opacity:0.9;}',
    '.wszq-url{font-size:11px;letter-spacing:0.05em;color:#8a8784;word-break:break-all;margin-top:14px;}',
    '.wszq-close{position:absolute;top:8px;right:8px;width:36px;height:36px;border:0;',
    'background:none;font-size:18px;color:#232323;cursor:pointer;padding:0;line-height:1;}'
  ].join('');
  var style = document.createElement('style');
  style.textContent = css;
  document.head.appendChild(style);

  function isSizeLabel(text) {
    var t = text.toLowerCase();
    return t.indexOf('size') !== -1 && t.indexOf('bead') === -1;
  }

  function openPopover() {
    var onComputer = window.innerWidth > DESKTOP_MIN_PX;
    var body =
      '<button type="button" class="wszq-close" aria-label="Close">&#10005;</button>' +
      '<h3 class="wszq-title">MEASURE YOUR WRIST</h3>' +
      '<p>Get your exact wrist size and matching bracelet size by resting your wrist on a phone screen.</p>';

    if (onComputer) {
      // On the website: show the QR so they can continue on their phone.
      var qr = qrSrc();
      body +=
        (qr ? '<img class="wszq-qr" src="' + qr + '" alt="QR code for the wrist sizer">' : '') +
        '<div class="wszq-scan">SCAN WITH YOUR PHONE CAMERA</div>' +
        '<div class="wszq-url">' + FULL_URL.replace('https://', '') + '</div>';
    } else {
      // On a phone: a button that opens the sizer in a new window.
      body +=
        '<a class="wszq-cta" href="' + FULL_URL + '" target="_blank" rel="noopener">MEASURE MY WRIST NOW</a>';
    }

    var overlay = document.createElement('div');
    overlay.className = 'wszq-overlay';
    overlay.innerHTML = '<div class="wszq-panel" role="dialog" aria-label="Measure your wrist">' + body + '</div>';
    overlay.addEventListener('click', function (e) {
      if (e.target === overlay || e.target.classList.contains('wszq-close')) overlay.remove();
    });
    document.body.appendChild(overlay);
  }

  function makeTrigger() {
    var a = document.createElement('a');
    a.className = 'wszq-trigger';
    a.href = PAGE_URL;        // graceful fallback if JS is blocked
    a.target = '_blank';
    a.rel = 'noopener';
    a.textContent = '?';
    a.setAttribute('aria-label', 'Measure my wrist');
    a.title = 'Measure my wrist';
    a.addEventListener('click', function (e) {
      // Always open the popout (stop the click focusing a dropdown label).
      e.preventDefault();
      e.stopPropagation();
      openPopover();
    });
    return a;
  }

  function scan() {
    // Button picker renders the option name in <legend class="form__label">,
    // the dropdown ("select size") picker in <label class="form__label">.
    // Cover both.
    var labels = document.querySelectorAll(
      'legend.form__label:not([data-wszq]), label.form__label:not([data-wszq])'
    );
    for (var i = 0; i < labels.length; i++) {
      var legend = labels[i];
      legend.setAttribute('data-wszq', '1');
      // Option name is the element's own leading text (value lives in a span)
      var name = '';
      for (var n = 0; n < legend.childNodes.length; n++) {
        if (legend.childNodes[n].nodeType === 3) name += legend.childNodes[n].textContent;
      }
      if (!isSizeLabel(name)) continue;
      // Put the ? to the RIGHT of the size (after the selected-value span).
      legend.appendChild(makeTrigger());
    }
  }

  scan();
  new MutationObserver(scan).observe(document.body, { childList: true, subtree: true });
})();
